import { CATALOG_DB_COLUMN_LABELS } from "./catalogFieldLabels";

/** Mirrors backend ALLOWED_DB_CROSSWALK_COLUMNS in product_code_regen/crosswalk.py */
export const DEFAULT_DB_CROSSWALK_COLUMNS = [
  "nome",
  "marca",
  "codice_prodotto",
  "peso",
  "codice_interno",
  "codice_ean",
  "descrizione",
  "link_offerta",
  "link_immagine",
  "link_immagine_1",
  "link_immagine_2",
  "albero_categorie",
  "prezzo_di_riferimento",
  "prezzo_vendita",
];

export const DEFAULT_CODE_SOURCES = ["internal", "ean"];

export const DEFAULT_MATCH_RULE = {
  feed_field: "",
  db_column: "",
};

export const EMPTY_MATCH_RULE = DEFAULT_MATCH_RULE;

export const DEFAULT_MATCH_LOGIC = "and";

export const MATCH_LOGIC_OPTIONS = [
  { value: "and", label: "AND (tutti gli abbinamenti)" },
  { value: "or", label: "OR (almeno un abbinamento)" },
];

export const CODE_SOURCE_LABELS = {
  internal: "Internal code (INT-*)",
  ean: "EAN (EAN-*)",
};

export const parseProductCodeRegenOptions = (payload, fieldKeys = []) => {
  const raw = payload || {};
  const dbColumns = raw.db_columns || raw.dbColumns || DEFAULT_DB_CROSSWALK_COLUMNS;
  const feedFields = raw.feed_fields || raw.feedFields || fieldKeys;
  const codeSources = raw.code_sources || raw.codeSources || DEFAULT_CODE_SOURCES;

  return {
    dbColumns: dbColumns.length > 0 ? dbColumns : DEFAULT_DB_CROSSWALK_COLUMNS,
    feedFields: feedFields.length > 0 ? feedFields : fieldKeys,
    codeSources: codeSources.length > 0 ? codeSources : DEFAULT_CODE_SOURCES,
  };
};

export const buildDbColumnOptions = (columns) => (
  (columns || DEFAULT_DB_CROSSWALK_COLUMNS).map((column) => ({
    value: column,
    label: CATALOG_DB_COLUMN_LABELS[column] || column,
  }))
);

export const buildFeedFieldOptions = (fields) => (
  [...new Set(fields || [])]
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b))
    .map((field) => ({ value: field, label: field }))
);

export const buildCodeSourceOptions = (sources) => (
  (sources || DEFAULT_CODE_SOURCES).map((source) => ({
    value: source,
    label: CODE_SOURCE_LABELS[source] || source,
  }))
);

export const buildMatchLogicOptions = () => MATCH_LOGIC_OPTIONS;

export const formatRegenMatchRuleLabel = (rule, dbColumnOptions = []) => {
  if (!rule) {
    return "";
  }
  const feedLabel = rule.feed_field || "—";
  const dbOption = dbColumnOptions.find((item) => item.value === rule.db_column);
  const dbLabel = dbOption?.label || rule.db_column || "—";
  return `${feedLabel} → ${dbLabel}`;
};

export const filterPreviewRowsByStatus = (rows, statusFilter) => {
  if (!statusFilter) {
    return rows || [];
  }
  return (rows || []).filter((row) => row?.status === statusFilter);
};
